export default {    
      down(url="",title=""){
        // 创建a标签，用于跳转至下载链接
        const tempLink = document.createElement("a");
        tempLink.style.display = "none";
        tempLink.href = url;
		tempLink.setAttribute("download", title||url);
        tempLink.setAttribute("target", "_blank");
        // 兼容：某些浏览器不支持HTML5的download属性
        if (typeof tempLink.download === "undefined") {
          tempLink.setAttribute("target", "_blank");
        }
        // 挂载a标签
        document.body.appendChild(tempLink);
        tempLink.click();
        document.body.removeChild(tempLink);
    },
    getAmzBigImg(src) {
      if (src) {
        if (src.indexOf("SS60") > -1) {
          return src.replace("SS60", "SS400");
        }
        if (src.indexOf("US40") > -1) {
          return src.replace("US40", "US400");
        }
        if (src.indexOf("US75") > -1) {
          return src.replace("US75", "US400");
        }
        if (src.indexOf("US20") > -1) {
          return src.replace("US20_", "US200_");
        }
		return src;
      } else {
        return "/static/image/error.png";
      }
    },
    // 获取时间段
    setTimes(name) {
      const start = new Date();
      const end = new Date();
      switch (name) {
        case "today":
          // 今天
          break;
        case "yesterday":
          // 昨天
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
          end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
          break;
        case "latelyweek":
          // 最近一周
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
          break;
        case "latelytwoweeks":
          // 最近两周
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 14);
          break;
        case "latelymonth":
          // 最近一个月
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
          break;
        case "lateday_90":
          // 最近90天
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
          break;
        case "thismonth":
          // 本月
          start.setTime(start.setDate(1));
          end.setTime(
            end.setDate(
              new Date(end.getFullYear(), end.getMonth() + 1, 0).getDate()
            )
          );
          break;
        case "lastmonth":
          // 上月
          start.setTime(
            new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1)
          );
          end.setTime(end.setDate(0));
          break;
        default:
          break;
      }
      return [start, end];
    },
    
            
}


// WEBPACK FOOTER //
// ./src/assets/js/common.js